<template>
  <div
    class="qaqc-pagination-container qaqc-overview-pagination"
    :class="{ 'qaqc-pagination--scorecard': variant === 'scorecard' }"
    v-if="totalItems > 0"
  >
    <div class="qaqc-pagination-left" v-if="!hidePageSize">
      <div class="qaqc-pagination-per-page">
        <v-select
          :model-value="itemsPerPage"
          @update:model-value="$emit('update:itemsPerPage', $event)"
          :items="pageSizes"
          variant="outlined"
          density="compact"
          hide-details
          class="qaqc-pagination-page-size-select items-per-page-select"
        ></v-select>
        <span class="qaqc-pagination-per-page-label">{{ itemsPerPageSuffix }}</span>
      </div>
    </div>
    <div class="qaqc-pagination-center" :class="{ 'qaqc-pagination-center--grow': hidePageSize }">
      <span class="qaqc-pagination-info">
        {{ startIndex + 1 }}-{{ endIndex }} of {{ totalItems }} {{ itemLabel }}
      </span>
    </div>
    <div class="qaqc-pagination-right">
      <v-btn
        icon="mdi-chevron-left"
        :variant="variant === 'scorecard' ? 'flat' : 'text'"
        :disabled="currentPage === 1"
        @click="$emit('update:currentPage', currentPage - 1)"
        class="qaqc-pagination-btn"
        :class="{ 'qaqc-pagination-btn--scorecard': variant === 'scorecard' }"
        :size="variant === 'scorecard' ? 'small' : undefined"
      ></v-btn>
      <v-btn
        icon="mdi-chevron-right"
        :variant="variant === 'scorecard' ? 'flat' : 'text'"
        :disabled="currentPage >= totalPages"
        @click="$emit('update:currentPage', currentPage + 1)"
        class="qaqc-pagination-btn"
        :class="{ 'qaqc-pagination-btn--scorecard': variant === 'scorecard' }"
        :size="variant === 'scorecard' ? 'small' : undefined"
      ></v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalItems: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
    itemLabel: { type: String, default: "Samples" },
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "scorecard"].includes(v),
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    itemsPerPageSuffix: {
      type: String,
      default: "items per page",
    },
    hidePageSize: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:currentPage", "update:itemsPerPage"],
  computed: {
    totalPages() {
      if (this.itemsPerPage <= 0) return 1;
      return Math.ceil(this.totalItems / this.itemsPerPage) || 1;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalItems);
    },
  },
};
</script>
